import { CssBaseline, CssVarsProvider } from "@mui/joy";
import React, { useEffect } from "react";
import { gottit } from "../themes/gottit";
import Wrapper from "./Wrapper";
import { RequestFCMPermission } from "../FCM";
import { messaging, onMessage } from "../firebase";

const App = () => {
  useEffect(() => {
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker
        .register("/service-worker.js")        
        .catch((error) => {
          console.error("Service Worker registration failed:", error);
        });
    }

    RequestFCMPermission();

    const unsubscribe = onMessage(messaging, (payload) => {
      const title = payload.notification?.title || "No Title";
      const body = payload.notification?.body || "No Body";

      if ("Notification" in window && Notification.permission === "granted") {
        if (
          "serviceWorker" in navigator &&
          navigator.serviceWorker.controller
        ) {
          // Use the service worker to show the notification on mobile
          navigator.serviceWorker.ready.then((registration) => {
            registration.showNotification(title, {
              body,
              icon: "/gotlogo.png",
            });
          });
        } else {
          // Fallback to the Notification API on desktop
          new Notification(title, {
            body,
            icon: "/gotlogo.png",
          });
        }
      }
    });

    return () => {
      unsubscribe();
    };
  }, []);

  return (
    <CssVarsProvider theme={gottit}>
      <CssBaseline />
      <Wrapper />
    </CssVarsProvider>
  );
};

export default App;
